export const stringifyDurationMixin = {
  methods: {
    stringifyDuration: function (rawDuration) {
      function roundUp (num, precision) {
        precision = Math.pow(10, precision);
        return Math.ceil(num * precision) / precision;
      }

      let durationString = '';
      if (Math.floor(rawDuration / 60) >= 1) {
        durationString += roundUp(rawDuration / 60, 1) + 'h';
      } else {
        if (rawDuration >= 1) {
          durationString += roundUp(rawDuration, 0) + 'm';
        }
      }
      return durationString.trim();
    },
  },
};
